"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Badge = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

require("./Badge.css");

var _Box = _interopRequireDefault(require("../../experimental/Box"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Badge = function Badge(_ref) {
  var children = _ref.children,
      className = _ref.className,
      variant = _ref.variant,
      restProps = _objectWithoutProperties(_ref, ["children", "className", "variant"]);

  return _react.default.createElement(_Box.default, _extends({}, restProps, {
    className: (0, _classnames.default)('vs-badge', "vs-badge-variant-".concat(variant), className)
  }), children);
};

exports.Badge = Badge;
Badge.defaultProps = {
  variant: '1'
};
Badge.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  variant: _propTypes.default.oneOf(['cj-green', '1', '2', '3', '4', '5', '6', '7', '8'])
};